import ApiService from ".";

const BASE_URL = () => {
  if (process.env.REACT_APP_ENV === "development")
    return process.env.REACT_APP_BASE_URL_DEVELOPMENT;
  else if (process.env.REACT_APP_ENV === "staging")
    return process.env.REACT_APP_BASE_URL_STAGING;
  else if (process.env.REACT_APP_ENV === "production") {
    return process.env.REACT_APP_BASE_URL_PRODUCTION;
  }
};
const FILE_BASE_URL = () => {
  if (process.env.REACT_APP_ENV === "development")
    return process.env.REACT_APP_FILES_DEVELOPMENT_BASE_URL;
  else if (process.env.REACT_APP_ENV === "staging")
    return process.env.REACT_APP_FILES_STAGING_BASE_URL;
  else if (process.env.REACT_APP_ENV === "production")
    return process.env.REACT_APP_FILES_PRODUCTION_BASE_URL;
  else return "https://app.foodiary.app/";
};

const trainer = new ApiService({ baseURL: BASE_URL(), loginType: "trainer" });
const client = new ApiService({
  baseURL: "https://app.foodiary.app/api",
  loginType: "user",
});
const ApiCollections = {
  // *********** Auth Module ********
  trainerSignUp: (params) => client.imgPost("trainerSignup", params),
  signIn: (params) => client.imgPost("trainerLogin", params),
  existingPlanSignIn: (params) => client.imgPost("trainerUserLogin", params),
  changePassword: (params) => client.post("reset-password", params),
  getTrainerProfile: (params) => trainer.post("app/user/showData", params),
  trainerDetailsEdit: (params) =>
    trainer.imgPost("app/user/trainerUpdate", params),
  registrationPart1: (params) => client.post("register", params),

  // *********** Nutrition Module ********
  getUserData: () => client.get("app/nutritionconcept"),
  getNutritionType: (params) => client.post("app/nutritiontype/show", params),
  getAllNutritionTypes: (params) =>
    client.post("app/nutritiontype/nutritionTypeList", params),
  updateNutritionType: (params) =>
    client.post("app/nutritiontype/nutritionTypeUpdate", params),
  updateNutritionCalories: (params) =>
    client.post("app/nutritiontype/caloriesUpdate", params),
  getNutritionAdvantages: (params) =>
    client.post("app/nutritiontype/advantagesData", params),
  getNutritionRecipes: (params) =>
    client.post("app/nutritiontype/receipeData", params),
  // getWeekWiseCaloriesData: (params) =>
  //   client.post("app/nutritiontype/weekWiseData", params),
  getWeekWiseCaloriesData: (params) =>
    client.post("coachdashboard/clients/nutritiontype/weekWiseData", params),
  getMacroNutrientsDonutData: (params) =>
    client.post("app/nutritiontype/pieChartData", params),
  getMacroNutrientsPieChartData: (params) =>
    client.postWithoutAuthorization(
      BASE_URL(),
      "coachdashboard/clients/nutritiontype/getPieChartData",
      params
    ),
  // *********** Health Score Module ********
  getSupplements: () => client.get("app/coachSupplement"),
  addProUserDataMailChimp: (params) =>
    client.post("app/mailchimpdata/addProUserDataMailchimp", params),
  addBasicUserDataMailChimp: (params) =>
    client.post("app/mailchimpdata/addBasicUserDataMailchimp", params),
  deleteMailChimpUserDetails: (params) =>
    client.post("app/mailchimpdata/deleteUserDetails", params),
  updateUserSubscription: (params) => client.post("app/coach/stripe", params),
};

export { FILE_BASE_URL };
export default ApiCollections;
